export const LOGIN = 'LOGIN'
export const LOGOUT = 'LOGOUT'
export const CLEAR_ERRORS = 'CLEAR_ERRORS'
export const GET_TOKEN = 'GET_TOKEN'
export const REFRESH = 'REFRESH'
export const RESET_PASSWORD = 'RESET_PASSWORD'
export const FIRST_TIME_LOGIN = 'FIRST_TIME_LOGIN'
export const GET_USER = 'GET_USER'
export const GET_VIOLATIONS = 'GET_VIOLATIONS'
export const SEARCH_VIOLATIONS = 'SEARCH_VIOLATIONS'
export const SEARCH_VIOLATION_FILTERS = 'SEARCH_VIOLATION_FILTERS'
export const SET_FORM = 'SET_FORM'
export const SET_VIOLATIONS = 'SET_VIOLATIONS'
export const SET_SEARCH_RESULTS = 'SET_SEARCH_RESULTS'

export const GET_COMMENTS = 'GET_COMMENTS'
export const GET_VIOLATION_TERMS = 'GET_VIOLATION_TERMS'
export const GET_ACTIONS = 'GET_ACTIONS'
export const GET_HISTORY = 'GET_HISTORY'
export const HAS_HISTORY = 'HAS_HISTORY'
export const SET_FLAG = 'SET_FLAG'
export const UPDATE_UNIT_TREE = 'UPDATE_UNIT_TREE'
export const UPDATE_VIOLATION = 'UPDATE_VIOLATION'
